import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FontAwesomeService} from '@services/font-awesome.service';
import {DateFormatPipe} from '@pipes/date-format.pipe';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-search-summary',
  templateUrl: './search-summary.component.html',
  styleUrls: ['./search-summary.component.scss']
})
export class SearchSummaryComponent implements OnInit {
  @Input() failure: boolean;
  @Input() data: any;
  @Input() index: number;
  @Output() reloadSearchResult: EventEmitter<any> = new EventEmitter();
  @Output() editSearchResult: EventEmitter<any> = new EventEmitter();
  @Output() deleteSearchResult: EventEmitter<any> = new EventEmitter();

  constructor(
    public faService: FontAwesomeService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
  }
  reload() {
    this.reloadSearchResult.emit();
  }

  edit() {
    this.editSearchResult.emit();
  }

  delete() {
    this.deleteSearchResult.emit();
  }

/*
public get pickupDate(): string {
const {startTime, endTime} = this.getTimespan(this.product.pickup_time_from, this.product.pickup_time_to);
const timeString =  this.translate.instant('common.date.timeLabel') + ' ' + startTime + '-' + endTime;

return `${(new DateFormatPipe(this.translate)).transform(
  this.product.pickup_date, 'mediumDate', '', this.translate.currentLang)}, ${timeString}`;
}
*/

}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/components/search-summary/search-summary.component.ts